/**
 * social-accounts.ts
 *
 * Centralized configuration for external social/profile links.
 * Each account entry includes:
 * - name
 * - href (full URL)
 * - Icon component (ReactNode)
 *
 * Fully compatible with:
 * - React 18+
 * - Node 18–24
 * - Next.js 13/14 (App or Pages Router)
 */

import type { FC } from "react";

import { SiFacebook } from "@react-icons/all-files/si/SiFacebook";
import { SiGithub } from "@react-icons/all-files/si/SiGithub";
import { SiGitlab } from "@react-icons/all-files/si/SiGitlab";
import { SiLinkedin } from "@react-icons/all-files/si/SiLinkedin";
import { SiTwitter } from "@react-icons/all-files/si/SiTwitter";

/** Shape of a social account configuration entry */
export interface SocialAccount {
  name: string;
  href: string;
  Icon: FC<{ className?: string }>;
}

/**
 * SOCIAL_ACCOUNTS
 * Mapped list of external profile links and icons.
 */
export const SOCIAL_ACCOUNTS: Record<string, SocialAccount> = {
  github: {
    name: "GitHub",
    href: "https://github.com/mattummal",
    Icon: ({ className = "" }) => <SiGithub className={className} />,
  },

  gitlab: {
    name: "GitLab",
    href: "https://gitlab.com/mattummal",
    Icon: ({ className = "" }) => <SiGitlab className={className} />,
  },

  twitter: {
    name: "Twitter",
    href: "https://x.com/prbhjyth",
    Icon: ({ className = "" }) => <SiTwitter className={className} />,
  },

  facebook: {
    name: "Facebook",
    href: "https://www.facebook.com/prabhjyoth/",
    Icon: ({ className = "" }) => <SiFacebook className={className} />,
  },

  linkedin: {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/prabhjyoth",
    Icon: ({ className = "" }) => <SiLinkedin className={className} />,
  },
};
